<template>
  <div class="sub-page">
    <div class="deleg-list">
      <template  v-if="delegationList.length>0">
        <div class="deleg-item" v-for="(item,index) in delegationList" :key="item.id" :style="{marginRight:index%5==4?'0':''}" @click="delegationDetail(item)">
          <div class="img-bg">
              <img class="logo"  :src="item.unitLogo" alt="" >
          </div>
          <div class="school">
            <div class="school-name">{{ item.unitName }}</div>
            <div class="line"></div>
          </div>
          <div class="info">
            <div class="left">
              <span class="num">{{ item.playerNum }}</span>
              <span class="p-name">运动员</span>
            </div>
            <div class="right">
              <span class="num">{{ item.projectNum }}</span>
              <span class="p-name">参赛项目</span>
            </div>
          </div>
        </div>
      </template>
      <div class="empty" v-else>
        <a-empty :image-style="{height: '60px',}" >
        <span slot="description"> 暂无数据 </span>
      </a-empty>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DelegationHome',
  props: {
  },
  data () {
    return {
      // delegationList:[
      //   {
      //     image: require('../../../assets/image/school/xpyz.jpg'),
      //     name:'重庆市西彭一中',
      //     players:13,
      //     programs:5,
      //     medal:1,
      //   },
      //   {
      //     image: 'https://static.daoba.com//210839871205.jpg',
      //     name:'重庆市金茂小学',
      //     players:7,
      //     programs:7,
      //     medal:2
      //   },
      //   {
      //     image: 'https://static.daoba.com/20220913105237.png',
      //     name:'重庆市高新育才学校',
      //     players:23,
      //     programs:2,
      //     medal:2
      //   },
      //   {
      //     image: require('../../../assets/image/school/tjb.png'),
      //     name:'重庆市田家炳中学',
      //     players:5,
      //     programs:5,
      //     medal:3,
      //   },
      //   {
      //     image: require('../../../assets/image/school/tlzx.jpg'),
      //     name:'重庆市铁路中学校',
      //     players:11,
      //     programs:3,
      //     medal:3
      //   },
      //   // {
      //   //   image:"https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/fa38d36c-3273-46ee-8b37-756ea2fa9acd-1639022024.jpeg?crop=0.497xw:0.994xh;0,0&resize=640:*",
      //   //   name:"代表团",
      //   //   players:11,
      //   //   programs:3,
      //   //   medal:3
      //   // },
      //   // {
      //   //   image:"https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/fa38d36c-3273-46ee-8b37-756ea2fa9acd-1639022024.jpeg?crop=0.497xw:0.994xh;0,0&resize=640:*",
      //   //   name:"代表团",
      //   //   players:5312,
      //   //   programs:323,
      //   //   medal:3
      //   // },
      //   // {
      //   //   image:"https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/fa38d36c-3273-46ee-8b37-756ea2fa9acd-1639022024.jpeg?crop=0.497xw:0.994xh;0,0&resize=640:*",
      //   //   name:"代表团",
      //   //   players:11321,
      //   //   programs:23,
      //   //   medal:3
      //   // },
      // ]
      delegationList:[],
    }
  },
  components: {},
  mounted () {
    this.getDelegationList()
  },
  methods: {
    delegationDetail (item){
      this.$router.push({
        name:'DelegationDetail',
        query:{ agencyId:item.id,unitName:encodeURIComponent(item.unitName),
      }})
    },
    //获取代表团数据
    async getDelegationList(){
      try {
        let res=await this.$api.district.delegationList()
        if(res.status ==0){
          this.delegationList=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        
      }
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page{
  width: 1200px;
  margin: 30px auto;
  background: #F1F1F1;
  box-shadow: 0px 2px 6px 0px rgba(33,26,30,0.08);
  border-radius: 10px;
  padding: 30px;
  .deleg-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .deleg-item{
      width: 210px;
      height: 300px;
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      background-color: #FFFFFF;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border-radius: 12px;
      cursor: pointer;
      padding-top: 15px;
      .img-bg{
        height: 140px;
        width: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FFFFFF;
        margin-bottom: 10px;
        border-radius: 10px;
        .logo{
            width: 110px;
            height: 110px;
          }
       
      }
      
      .school{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        text-align: center;
        padding: 0 5px ;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        overflow-wrap: break-word;
        word-break: break-all;
        white-space: normal;
        overflow: hidden;
        .school-name{
          height: 60px;
        }
        .line{
          height: 1px;
          width: 90%;
          background-color: #DDDDDD;
          // margin-top: 15px;
        }
      }

      .info{
        width: 100%;
        max-height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 0 20px;
        margin-top: 5px;
        span{
          display: inline-block;
        }
        
        .left{
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          color: #999999;
          .num{
            font-size: 22px;
            font-weight: bold;
            color: #333333;
            overflow: hidden;
          }
        }
        .right{
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          text-align: center;
          justify-content: center;
          flex-direction: column;
          color: #999999;
          .num{
            font-size: 22px;
            font-weight: bold;
            color: #333333;
          }
        }
      }
      .nonius{
        width: 50px;
        height: 50px;
        position: absolute;
        right: 5px;
        bottom: 2px;
      }
    }
    .deleg-item:last-child{
      margin-right:auto;
    }
    .empty{
      width: 100%;
      min-height: 250px;
      padding-top: 90px;
      margin: 0 auto;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/district/views/delegation/components/DelegationHome.vue